import type { GetPayJunctionResponse } from "@/openapi/generated/models";

/**
 * PayJunction GET options map `key` to the app key and `publishableKey` to the
 * frontend tokenization key. Never use `key` for card tokenization.
 */
export function getPayJunctionPublishableKey(
  options: GetPayJunctionResponse | null | undefined,
): string | null {
  const publishableKey = options?.publishableKey?.trim();
  return publishableKey || null;
}

export function hasPayJunctionPublishableKey(
  options: GetPayJunctionResponse | null | undefined,
): boolean {
  return getPayJunctionPublishableKey(options) != null;
}
